export const LANGUAGE = 'language';
export const LAST_SIGN_IN_METHOD = 'lastSigninMethod';
export const DISMISSED_PIN_TO_HOME_PROMPT = 'dismissedPinToHomePrompt';

export const USER_PREFERENCE_KEYS = {
	LANGUAGE,
	LAST_SIGN_IN_METHOD,
	DISMISSED_PIN_TO_HOME_PROMPT,
};
